var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:[
		("alert-" + _vm.type),
		_vm.error ? 'px-3 py-2 mt-2' : null
	],attrs:{"role":"alert"}},[(_vm.title)?_c('h4',{staticClass:"alert-heading"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }